import styled from "styled-components"

const AdditionalInfos = styled.section`
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const ActuTaxo = styled.span`
  background-color: ${(props) => props.theme.c_color_gradients.c_dark};
  color: ${(props) => props.theme.a_color_gradients.a_dark};
`

const ActuTitle = styled.h1`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

const ActualiteFooterContainer = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_medium};
`

export { AdditionalInfos, ActuTaxo, ActuTitle, ActualiteFooterContainer }
